import { BillingPaymentMethodType } from "@api/shared-runtime/enums";

export type SavedPaymentMethod = {
  type: BillingPaymentMethodType;
  label: string | null;
  last4: string | null;
};

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/** Card brands arrive lowercase from Stripe; bank names are already cased. */
export function formatPaymentMethod(method: SavedPaymentMethod): string {
  const last4 = method.last4 ?? "????";
  if (method.type === BillingPaymentMethodType.UsBankAccount) {
    return `${method.label ?? "Bank"} account ending in ${last4}`;
  }
  return `${capitalize(method.label ?? "card")} ending in ${last4}`;
}
